import { render, staticRenderFns } from "./DashboardAssessmentCard.vue?vue&type=template&id=09fbbb6e&scoped=true"
import script from "./DashboardAssessmentCard.vue?vue&type=script&lang=ts"
export * from "./DashboardAssessmentCard.vue?vue&type=script&lang=ts"
import style0 from "./DashboardAssessmentCard.vue?vue&type=style&index=0&id=09fbbb6e&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "09fbbb6e",
  null
  
)

export default component.exports